var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "grid h-color-fuel-navy files__file-link",
      attrs: { href: _vm.file.file_url || "" },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.followLink($event)
        }
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--11 h-no-margin h-no-padding" }, [
        _vm._v(_vm._s(_vm.file.file_name))
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__col--1 h-no-padding h-center-align" },
      [
        _c("span", {
          staticClass: "glyphicon glyphicon-cloud-download",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }